import React from 'react';
import { Typography } from '@mui/material';

const SaveAndExportJoyrideContent = (props) => {
    return (
        <Typography variant='body2' align='left'>
            Save changes and export the finished video.
            After the export is started, it will take a few minutes for the export to complete.
            Once it has completed, the exported video can be seen and downloaded from the "My Videos" page.
            Pressing CMD/CTRL + 's' is another way to save changes.
        </Typography>
    );
};

export default SaveAndExportJoyrideContent;
